import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';

import theme from '@app/styles/theme';
import {
  screenExtraSmall,
  screenMedium,
  screenSmall,
} from '@app/styles/theme/breakpoints';
import { rem } from '@app/styles/theme/layout';

const image: SerializedStyles = css`
  height: 1rem;
  margin: 0 0.5rem 1rem;
  object-fit: contain;
  flex: 1 0 20%;
  max-width: calc(25% - 1rem);

  @media screen and (min-width: ${screenExtraSmall}) {
    height: ${rem(20)};
    max-width: calc(20% - 1rem);
  }

  @media screen and (min-width: ${screenSmall}) {
    height: ${rem(30)};
    margin: 0 0 1rem;
    flex: 1 0 20%;
  }

  @media screen and (min-width: ${screenMedium}) {
    flex: none;
  }
`;

const link: SerializedStyles = css`
  &:hover {
    color: ${theme.colors.protectedContentLinkHover};
  }
`;

export { image, link };
